import { createSelector } from 'reselect';

import { getNavigation } from '../../selectors/MasterSetupPageSelectors';

export const getAppMigration = (state) => state.appMigration;

export const getImport = createSelector(getAppMigration, (appMigration) => appMigration?.import);

export const getCurrentImportKey = createSelector(
  getAppMigration,
  (appMigration) => appMigration?.import?.currentImportKey
);

export const getImportProp = (importKey, propName) =>
  createSelector(getImport, (importState) => importState?.importItems[importKey]?.[propName]);

export const getStepIdProp = (entityName) =>
  createSelector(getNavigation, (navigation) => {
    let stepId = '';

    if (Array.isArray(navigation)) {
      navigation.forEach((navItem) => {
        const templateData = navItem?.contentInfos?.menu?.contentData?.templateData;
        if (Array.isArray(templateData)) {
          templateData.forEach((data) => {
            const links = data?.Links;
            if (Array.isArray(links)) {
              const linkData = links.find((link) => link.EntityName === entityName);
              if (linkData) {
                stepId = linkData.StepId;
              }
            }
          });
        }
      });
    }

    return stepId;
  });
